var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{staticClass:"expand-arrow",class:{ 'expanded': _vm.expanded },attrs:{"icon-name":"expand_more","weight":"bold","size":"24px"}})}
var staticRenderFns = []

export { render, staticRenderFns }